// The frame of the pages before the console (02-DESIGN/03-console/
// 01-the-console.md § signing in): the mark and the wordmark, one card, and
// what sits quietly under it.

import type { ReactNode } from "react";

import { Wordmark, type Live } from "../../shell/Mark.tsx";

export function Entry({ live, children, under }: { live?: Live; children: ReactNode; under?: ReactNode }) {
  return (
    <div className="entry">
      <Wordmark live={live} />
      {children}
      {under !== undefined && <div className="entry-under">{under}</div>}
    </div>
  );
}
